// 消息模板

import TextTip from './TextTip'     //  文字提示，主要用于排队提示
import TimeTip from './TimeTip'     //  时间提示，每半小时提示一次
import TplText from './TplText'      // 普通文本消息模板
import TplImage from './TplImage'      // 图片消息模板
import TplFile from './TplFile'      // 文件消息模板
import TplToCustomer from './TplToCustomer'     //  转接人工客服消息模板
import TplLoading from './TplLoading'       // loading
import TplQsList from './TplQsList'     //  消息列表模板
import BaseFrame from './BaseFrame'       // 聊天框基本结构

export default {
  TextTip,
  TimeTip,
  TplText,
  TplImage,
  TplFile,
  TplToCustomer,
  TplLoading,
  TplQsList,
  BaseFrame
}



// WEBPACK FOOTER //
// ./src/components/templates/index.js